export default __webpack_public_path__ + "static/media/kitchen3-afterJ-1440w.88c60224.png";